<template>
<div class="chapter">
<div class="inner_page">
<p class="p4"><span class="t10">BOOKS BY RICK R. REED </span></p>
<p class="p5"><span class="t12">Obsessed<br/>Penance<br/>A Face Without a Heart <br/>IM<br/>Third Eye<br/>Blood Sacrifice<br/>Caregiver<br/>Hungry for Love<br/>Legally Wed<br/>Dinner at Home<br/>Dinner at Fiorello’s<br/>Dinner at Jack’s<br/>Dinner at the Blue Moon Cafe´<br/>M4M<br/>Mute Witness<br/>A Demon Inside<br/>Blink<br/>Chaser<br/>Raining Men<br/>The Couple Next Door Tricks<br/>A Dangerous Game </span><br/><span class="t12">Bashed<br/>Orientation<br/>Dead End Street<br/>High Risk<br/>Stranded with Desire (with Vivien Dean)<br/>The Perils of Intimacy<br/>Husband Hunters<br/>Lost and Found<br/>Big Love<br/>Bigger Love<br/>Sky Full of Mysteries<br/>Torn<br/>Blue Umbrella Sky<br/>The Secrets We Keep<br/>Unraveling<br/>The Man from Milwaukee<br/>The Q</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?a807abb0